import { Link } from "react-router-dom";
import { Fingerprint } from "lucide-react";
import { useTranslation } from "../../../i18n/useTranslation";

const Home = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* hero */}
      <div className="band-hero section text-center">
        <Fingerprint className="mx-auto seal-hero" size={132} strokeWidth={1} style={{ color: "var(--gold)" }} />
        <h1>{t("home.heroTitleLine1")}<br />{t("home.heroTitleLine2")}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("home.heroSub")}</p>
        </div>
        <div className="pt-6">
          <Link to="/trusted-ecosystem" className="btn-brass">{t("home.ctaMission")}</Link>
        </div>
      </div>

      {/* solutions teaser */}
      <div className="band-a section-tight">
        <div className="max-w-xl mx-auto text-center">
          <div className="eyebrow">{t("home.solutionsEyebrow")}</div>
          <h2>{t("home.solutionsHeading")}</h2>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 px-5 py-8">
          <div className="card-ledger text-center">
            <img src={require("../../../img/web/market/itrust.png")} alt="" width="44" height="44" className="mx-auto" />
            <h3>iTrust.ID</h3>
            <p className="mini">Trust for everyone, everywhere.</p>
          </div>
          <div className="card-ledger text-center">
            <img src={require("../../../img/web/knowus/work/talent/lifecycle.png")} alt="" width="44" height="44" className="mx-auto" />
            <h3>DeviceWorks</h3>
            <p className="mini">Device lifecycle, managed end to end.</p>
          </div>
        </div>
        <div className="text-center pt-2">
          <Link to="/solutions" className="btn-outline">{t("home.seeAllSolutions")}</Link>
        </div>
      </div>

      {/* markets teaser */}
      <div className="band-b section-tight">
        <div className="max-w-xl mx-auto text-center">
          <div className="eyebrow">{t("home.marketsEyebrow")}</div>
          <h2>{t("home.marketsHeading")}</h2>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 px-5 py-8">
          <div className="card-ledger text-center">
            <span className="tag-verdigris">HQ · IN</span>
            <h3>India</h3>
            <p className="mini">Headquarters, and our founding market.</p>
          </div>
          <div className="card-ledger text-center">
            <span className="tag-verdigris">Market · US</span>
            <h3>USA</h3>
            <p className="mini">Our second operating market.</p>
          </div>
        </div>
        <div className="text-center pt-2 pb-3">
          <Link to="/markets" className="btn-outline">{t("home.seeAllMarkets")}</Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
